import React from 'react'
import { UserPlusIcon } from 'assets'
import { constants, findPermission, getStorage } from 'helpers'

type BulkEnrollmentSearchButtonProps = {
    onClick: () => void
}

export const BulkEnrollmentSearchButton = ({
    onClick
}: BulkEnrollmentSearchButtonProps) => {
    const canViewBulkEnrollment = findPermission(
        getStorage(constants.USER_PERMISSIONS),
        constants.CAN_VIEW_BULK_ENROLLMENT
    )

    if (!canViewBulkEnrollment) {
        return null
    }

    return (
        <button
            type="button"
            className="search-bar-bulk-btn"
            aria-label="open bulk enrollment"
            onClick={onClick}
            id="bulk-enrollment-search-btn"
        >
            <UserPlusIcon />
        </button>
    )
}
